export const PostFeedType = {
  ALL: 'ALL',
  NEWS_ITEM: 'NEWS_ITEM',
  GOSSIP: 'GOSSIP',
  HAPPENING: 'HAPPENING',
  MARKET: 'MARKET',
  SUGGESTION: 'SUGGESTION',
  SPECIAL_POST: 'SPECIAL_POST',
  EMERGENCY: 'EMERGENCY',
  CIVIL_PROTECTION: 'CIVIL_PROTECTION'
} as const;

export type PostFeedType = (typeof PostFeedType)[keyof typeof PostFeedType];
